import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SimplebarAngularModule } from 'simplebar-angular';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {NgClickOutsideDirective, NgClickOutsideExcludeDirective} from 'ng-click-outside2';

import { UIModule } from '../shared/ui/ui.module';
import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';
import { RightsidebarComponent } from './rightsidebar/rightsidebar.component';
import { HorizontalComponent } from './horizontal/horizontal.component';
import { VerticalComponent } from './vertical/vertical.component';
import { HorizontaltopbarComponent } from './horizontaltopbar/horizontaltopbar.component';
import { LanguageService } from '../core/services/language.service';
import { TranslateModule } from '@ngx-translate/core';
import { ModalformComponent } from './modalform/modalform.component';
import { ChatUIModule } from '@syncfusion/ej2-angular-interactive-chat';
// mospina 14-10-26 EPT-2103 Avisos institucionales dentro del sistema
import { AvisosSistemaComponent } from './avisos-sistema/avisos-sistema.component';
import { CambiarContrasenaComponent } from './cambiar-contrasena/cambiar-contrasena.component';


@NgModule({
  // tslint:disable-next-line: max-line-length
  declarations: [LayoutComponent, SidebarComponent, TopbarComponent, FooterComponent, RightsidebarComponent, HorizontalComponent, VerticalComponent, HorizontaltopbarComponent, ModalformComponent, AvisosSistemaComponent, CambiarContrasenaComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    RouterModule,
    NgbDropdownModule,
    NgClickOutsideDirective,
    UIModule,
    SimplebarAngularModule,
    NgbModule,
    NgClickOutsideExcludeDirective,
    ChatUIModule
  ],
  exports:[
    FooterComponent
  ],
  providers: [LanguageService]
})
export class LayoutsModule { }
